import { Checkbox, Collapse } from 'antd';
import './index.less';
import ArrowButtonDownIcon from '@/components/Common/Icons/ArrowButtonDownIcon';
import { ISourcingFilterOption } from '@/shared/types/sourcing-marketplace';

interface SourcingFilterContainerProps {
  title: string;
  options: ISourcingFilterOption[];
  selectedOption: any;
  defaultActiveKey?: string[];
  onOptionClick: (option: ISourcingFilterOption) => void;
  renderItemLabel?: (option: ISourcingFilterOption) => React.ReactNode;
}

const SourcingFilterContainer = ({
  title,
  options,
  selectedOption,
  onOptionClick,
  defaultActiveKey,
  renderItemLabel,
}: SourcingFilterContainerProps) => {
  return (
    <Collapse
      className="sourcing-filter-container-box"
      expandIconPosition="end"
      expandIcon={(v) => (
        <div style={{ transition: 'all 0.3s', transform: `rotate(${v.isActive ? '0' : '180'}deg)` }}>
          <ArrowButtonDownIcon fill="#6B6B6B" />
        </div>
      )}
      defaultActiveKey={defaultActiveKey}
      ghost
      items={[
        {
          key: title,
          label: title,
          children: (
            <div className="options">
              {options.map((item, index) => (
                <Checkbox
                  key={index}
                  className="option radio"
                  checked={selectedOption === item.value}
                  onClick={() => onOptionClick(item)}
                >
                  {renderItemLabel ? renderItemLabel(item) : item.label}
                </Checkbox>
              ))}
            </div>
          ),
        },
      ]}
    />
  );
};

export default SourcingFilterContainer;
